export default "__VITE_ASSET__9tvVqtlh__"